<div class="wrapper-title">
	<div class="title">
		<h5>{{ title }}</h5>
	</div>
	<div class="sub-title">
		<h6>{{ subTitle }}</h6>
	</div>
	<ng-content></ng-content>
</div>
